export const ROW_TYPES_WITHOUT_POPOVER = ["collapse", "tabs", "carousel"];

export const showCanvasSelectLabel = (detail) => {
  document.dispatchEvent(
    new CustomEvent("showCanvasSelectLabel", {
      detail,
    })
  );
};

export const hideCanvasSelectLabel = (source) => {
  document.dispatchEvent(
    new CustomEvent("hideCanvasSelectLabel", { detail: { source } })
  );
};

export const isCanvasSelectLabelTarget = (target) => {
  return !!target?.closest?.(".select-label");
};

export const dispatchPopover = (detail) => {
  document.dispatchEvent(new CustomEvent("showPopover", { detail }));
};
